import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import PrimarySearchAppBar from "../components/PrimarySearchAppBar";
import { useAuth0 } from "@auth0/auth0-react";
import { useAppMetadata } from "../auth0/Auth0MetaData";
import { ResultJSON } from '../components/ResultJSON';
import { FIPOKGame } from '../components/FIPOKGame';
import { Domains } from '../Utils';

export const GamePage = () => {
	const auth0Obj = useAuth0();
	const { user }= auth0Obj;
	const appMetadata = useAppMetadata();
	const isAuthenticated = auth0Obj.isAuthenticated;
	console.log("isAuth: ", isAuthenticated);
	const { symbolicId } = useParams() as { symbolicId: string };

	function getUserJSON()
	{
		let rv = null;
		if ( user ) {
			rv = user;
			if ( appMetadata ) {
				rv.appMetadata = appMetadata;
			}
		}
		return rv;
	}

	return (
		<Box display={"flex"} flexDirection={"column"} height={"100vh"}>
			<PrimarySearchAppBar />
			{ !isAuthenticated && (
				<Box>
					A tartalom megtekintéséhez be kell jelentkeznie.
					You are not authenticated. Log in to see the contents.
				</Box>
			) }
			{ isAuthenticated && (
				<ResultJSON bucketBaseURL = {Domains.gamesURL} code={'games'}>
					<FIPOKGame section={'cognitive'} symbolicId={symbolicId}/>
				</ResultJSON>
			) }
		</Box>
	);
};
